import React from "react";
import Qpentreg from "./Qpentreg";
import Qpcorreo from "./Qpcorreo";
import { mensajeError } from "./simulab";

/**
 * «Qué pasó»: la foto de la entrega al transportador del DO, en lenguaje simple, para ver el efecto de cada botón.
 * Lee el bloqueo y la tarea tal como vengan (sin suponer que la tarea existe ni en qué estado nace).
 * @param {object} props
 * @param {object} [props.foto] Respuesta de /laboratorio/quePaso
 * @param {boolean} props.cargando Consultando
 * @param {object} [props.error] Error de la consulta
 * @param {Function} props.onRefrescar Vuelve a consultar
 * @author Claude Code (Alexandra Parra) <direccionit.siaco@repremundo.com.co>
 * @since 2026-10-26
 */
const Quepasox = ({ foto, cargando, error, onRefrescar }) => (
  <div className="rio-card sim-paso">
    <div className="sim-paso-cabeza">
      <div className="rio-card-title">Qué pasó</div>
      <button type="button" className="rio-icon-btn" onClick={onRefrescar} disabled={cargando}>{cargando ? "Consultando…" : "Actualizar"}</button>
    </div>
    {error ? <div className="sim-resultado mal">{mensajeError(error)}</div> : null}
    {foto ? (
      <>
        <Qpentreg foto={foto} />
        <Qpcorreo foto={foto} />
        <Qptrazax traza={foto.TRAZA ?? []} />
      </>
    ) : null}
  </div>
);

/**
 * Línea de tiempo de la operación (MDTR), la más reciente arriba; lo simulado marcado en coral.
 * @param {object} props
 * @param {Array<object>} props.traza Entradas {REGFECXX, REGHORXX, MDTRTIPO, MDTROBSX}
 * @returns {JSX.Element}
 */
const Qptrazax = ({ traza }) => (
  <div className="sim-qp-caja">
    <div className="sim-qp-frase">Seguimiento de la operación (lo último arriba)</div>
    {traza.length === 0 ? <span className="sim-vacio">Sin anotaciones.</span> : null}
    <ul className="sim-traza">
      {traza.map((m, i) => (
        <li key={`${m.REGFECXX}-${m.REGHORXX}-${i}`} className={/SIMULACION|SIMULADOR|SIMULAD/i.test(m.MDTROBSX) ? "simulado" : ""}>
          <time>{`${m.REGFECXX} ${m.REGHORXX}`}</time>
          {m.MDTROBSX}
        </li>
      ))}
    </ul>
  </div>
);

export default Quepasox;
